<template>
  <div class="flex justify-between w-44 h-max">
    <a
      class="social-link"
      :href="item.link"
      target="_blank"
      rel="noopener noreferrer"
      v-for="(item, i) in items"
      :key="i"
    >
      <img :src="item.src" :alt="item.alt" class="size-[2.125rem]" />
    </a>
  </div>
</template>

<script>
export default {
  computed: {
    items () {
      const locale = this.$i18n.locale

      // Для русскоязычных стран
      if (locale === 'ru' || locale === 'kk') {
        return [
          { src: require('../assets/img/anchors/tg.svg'), alt: 'Telegram', link: '//t.me/lr_dev' },
          { src: require('../assets/img/anchors/vk.svg'), alt: 'VK', link: '//vk.com/liverussia.online' },
          { src: require('../assets/img/anchors/discord.svg'), alt: 'Discord', link: '//discord.com/Hs99taWPAy' }
        ]
      }

      // Для Бразилии
      if (locale === 'bz') {
        return [
          { src: require('../assets/img/anchors/tg.svg'), alt: 'Telegram', link: '//t.me/lr_brazil' },
          { src: require('../assets/img/anchors/facebook.svg'), alt: 'Facebook', link: '//facebook.com/groups/liverussia.online' },
          { src: require('../assets/img/anchors/x.svg'), alt: 'X', link: '//x.com/liverussimobile' },
          { src: require('../assets/img/anchors/discord.svg'), alt: 'Discord', link: '//discord.gg/Hs99taWPAy' }
        ]
      }

      // Для остальных стран
      return [
        { src: require('../assets/img/anchors/tg.svg'), alt: 'Telegram', link: '//t.me/liverussia_global' },
        { src: require('../assets/img/anchors/facebook.svg'), alt: 'Facebook', link: '//facebook.com/groups/liverussia.online' },
        { src: require('../assets/img/anchors/x.svg'), alt: 'X', link: '//x.com/liverussimobile' },
        { src: require('../assets/img/anchors/discord.svg'), alt: 'Discord', link: '//discord.gg/Hs99taWPAy' }
      ]
    }
  }
}
</script>

<style scoped>
.social-link { display: block; flex-shrink: 0; border-radius: 5px; }
.social-link img { display: block; transition: filter 150ms; }
.social-link:hover img,
.social-link:focus-visible img { filter: brightness(1.25) drop-shadow(0 0 6px #97bbf066); }
.social-link:focus-visible { outline: 2px solid #97bbf0; outline-offset: 3px; }
</style>
